var map = {
	"./_logo.svg": 299,
	"./arr.svg": 300,
	"./arrow.svg": 301,
	"./auto.svg": 302,
	"./box.svg": 303,
	"./brain.svg": 304,
	"./briefcase-outline.svg": 305,
	"./burger.svg": 306,
	"./charity.svg": 307,
	"./clip.svg": 308,
	"./clock.svg": 309,
	"./close.svg": 310,
	"./connections.svg": 311,
	"./copy.svg": 312,
	"./correct.svg": 313,
	"./credit-card.svg": 314,
	"./cross.svg": 315,
	"./cube-with-arrows.svg": 316,
	"./diameter-roll.svg": 317,
	"./diameter-sleeve.svg": 318,
	"./doc.svg": 319,
	"./download.svg": 320,
	"./experience.svg": 321,
	"./eye.svg": 322,
	"./facebook-logo.svg": 323,
	"./factory.svg": 324,
	"./favorites.svg": 325,
	"./file.svg": 326,
	"./gauge.svg": 327,
	"./group-people.svg": 328,
	"./growth.svg": 329,
	"./hand-shake.svg": 330,
	"./hand.svg": 331,
	"./increase.svg": 332,
	"./load-more.svg": 333,
	"./logo.svg": 334,
	"./notebook.svg": 335,
	"./pdf.svg": 336,
	"./phone-receiver.svg": 337,
	"./pin.svg": 338,
	"./placeholder.svg": 339,
	"./play-link.svg": 340,
	"./play_btn.svg": 341,
	"./sand-clock.svg": 342,
	"./search.svg": 343,
	"./search_blue.svg": 344,
	"./sprout-greenhouse.svg": 345,
	"./sprout.svg": 346,
	"./tactics.svg": 347,
	"./telemarketer.svg": 348,
	"./train.svg": 349,
	"./twitter.svg": 350,
	"./video-play.svg": 351,
	"./vk.svg": 352,
	"./weight.svg": 353,
	"./width-roll.svg": 354,
	"./xls.svg": 355,
	"./zoom.svg": 356
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 225;


//////////////////
// WEBPACK FOOTER
// ../img/sprite nonrecursive \.svg$
// module id = 225
// module chunks = 0